<template>
  <div>
    <div class="componentTop">
      <div class="componentText">题目设置</div>
      <div>
        <a-button type="primary" icon="plus" :disabled="attAssignmentList.length >= 5" @click="showModal()">
        新建附件题
      </a-button>
      </div>
    </div>
    <div class="tipsDesc">研修作业仅支持“附件题”，每道题目以上传1个附件的形式进行作答，一个作业最多支持5道题目</div>
    <div class="courseworkList">
      <a-table :columns="columns" :dataSource="attAssignmentList" rowKey="attAssignmentId" :pagination="false">
        <div slot="assignmentTypeFormat" slot-scope="assignmentTypeFormat">
          <span v-if="assignmentTypeFormat.assignmentTypeFormat == '1'">文档</span>
          <span v-if="assignmentTypeFormat.assignmentTypeFormat == '2'">音视频</span>
        </div>
        <div slot="operation" slot-scope="operation">
          <a @click="editAttach(operation)">编辑</a>
          <a-divider type="vertical" />
          <a @click="delAssignment(operation.attAssignmentId)">删除</a>
          <a-divider type="vertical" />
          <a @click="moveUp(operation)">上移</a>
          <a-divider type="vertical" />
          <a @click="moveDown(operation)">下移</a>
        </div>
      </a-table>
    </div>
    <SetAttachment ref="SetAttachment" @getOneAttInfo="getOneAttInfo"></SetAttachment>
  </div>
</template>

<script>
import SetAttachment from './setAttachment';

const columns = [
  {
    title: '序号',
    dataIndex: 'orderNo',
    key: 'orderNo',
    width: 100
  },
  {
    title: '题目标题',
    dataIndex: 'assignmentName',
    key: 'assignmentName'
  },
  {
    title: '附件格式',
    key: 'assignmentTypeFormat',
    scopedSlots: { customRender: 'assignmentTypeFormat' },
    width: 150
  },
  {
    title: '操作',
    key: 'operation',
    width: 220,
    scopedSlots: { customRender: 'operation' }
  }
];

export default {
  data(){
    return {
      columns,
      attAssignmentList: []
    };
  },
  components: {
    SetAttachment
  },
  created () {
    this.getOneAttInfo();
  },
  methods: {
    showModal(){
      this.$refs.SetAttachment.showModal();
    },
    getOneAttInfo(){
      let url = this.apis.coursework.getOneAttInfoById + this.appUtils.getCourseInfo().attinfoId;
      this.http.get(url)
      .then((res)=>{
        this.attAssignmentList = res.data.attAssignmentList;
      }).catch((err)=> {
        console.log(err);
      });
    },
    moveAssignment(attIds){
      let url = this.apis.coursework.moveAssignment;
      this.http.post(url, attIds)
      .then((res)=>{
        if (res.status == 0){
          this.$message.success('修改题目顺序成功');
          this.getOneAttInfo();
        } else {
          this.$message.error(res.message);
        }
      }).catch((err)=> {
        console.log(err);
      });
    },
    delAssignment(attId){
      let that=this;
      this.$confirm({
        title: '您确定要删除该题目吗?',
        onOk() {
          that.sbmDelAssignment(attId);
        },
        onCancel() {
        }
      });
    },
    sbmDelAssignment(attId){
      let url = this.apis.coursework.delAssignment + attId;
      this.http.delete(url)
      .then((res)=>{
        if (res.status == 0){
          this.$message.success('删除附件题成功');
          this.getOneAttInfo();
        } else {
          this.$message.error(res.message);
        }
      }).catch((err)=> {
        console.log(err);
      });
    },
    editAttach(item){
      this.$refs.SetAttachment.editAttachMsg(item);
    },
    moveUp(item){
      let currentAttAssignmentId = item.attAssignmentId;
      let lastAttAssignmentId = '';
      let attIds = [];
      let attAssIdx = (this.attAssignmentList || []).findIndex((attAss) => attAss.attAssignmentId === currentAttAssignmentId);
      this.attAssignmentList.forEach((val)=>{
        attIds.push(val.attAssignmentId);
      });
      if (attAssIdx == 0){
        this.$message.warning('该题目已经排在第一位了');
        return false;
      } else if (attAssIdx >= 1){
        lastAttAssignmentId = this.attAssignmentList[attAssIdx-1].attAssignmentId;
        attIds[attAssIdx-1] = currentAttAssignmentId;
        attIds[attAssIdx] = lastAttAssignmentId;
        this.moveAssignment(attIds);
      }
    },
    moveDown(item){
      let currentAttAssignmentId = item.attAssignmentId;
      let nextAttAssignmentId = '';
      let attIds = [];
      let attAssIdx = (this.attAssignmentList || []).findIndex((attAss) => attAss.attAssignmentId === currentAttAssignmentId);
      this.attAssignmentList.forEach((val)=>{
        attIds.push(val.attAssignmentId);
      });
      if (attAssIdx == this.attAssignmentList.length-1){
        this.$message.warning('该题目已经排在最后一位了');
        return false;
      } else if (attAssIdx <= this.attAssignmentList.length-2){
        nextAttAssignmentId = this.attAssignmentList[attAssIdx+1].attAssignmentId;
        attIds[attAssIdx+1] = currentAttAssignmentId;
        attIds[attAssIdx] = nextAttAssignmentId;
        this.moveAssignment(attIds);
      }
    }
  }
};
</script>

<style lang="less" scoped>
  .componentTop{
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;
    padding: 25px 40px;
  }
  .componentText{
    font-size: 30px;
    color: #333333;
  }
  .tipsDesc{
    padding: 0 40px;
    color: #999;
    text-align: start;
    margin-bottom: 24px;
  }
  .courseworkList{
    padding: 0 50px 50px 30px;
    text-align: start;
    .oneCoursework{
      border:1px solid rgba(232,232,232,1);
      box-shadow:0px 4px 12px rgba(238,238,238,1);
      border-radius:2px;
      margin-bottom: 25px;
      .courseworkTop{
        height: 80px;
        background: #FAFAFA;
        border-bottom: 1px solid #E8E8E8;
        padding: 16px 43px 12px 25px;
        .titleBox{
          height: 24px;
          line-height: 24px;
          .title{
            width: 60%;
            font-size: 16px;
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
          }
          span{
            display: inline-block;
            width: 24px;
            height: 24px;
            cursor: pointer;
            img{
              width: 100%;
              height: 100%;
              object-fit: contain;
            }
          }
        }
        .titleDesc{
          margin-top: 5px;
          color: #999;
        }
      }
      .courseworkMain{
        padding: 25px 43px 20px 25px;
        h4{
          color: #666;
        }
        p{
          color: #999;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }
</style>